import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const Tip = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['light']};
  font-size: ${30 * Screen.widthRatio}px;
  height: ${36 * Screen.widthRatio}px;
  width: ${600 * Screen.widthRatio}px;
`;

export default Tip;
